import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
/**
 * Factory for the "shell hands a module its permission booleans via React
 * context" boilerplate that every `admin-module-*` package repeated
 * verbatim (createContext + Provider component + useContext reader) — see
 * M-028. Each module still owns its own `XPermissionContext` shape and
 * `defaults`; this only centralizes the plumbing around it.
 *
 * ```ts
 * export interface ChannelsPermissionContext { canManage: boolean }
 * const { Provider: ChannelsModulePermsProvider, usePerms: useChannelsPerms } =
 *   createModulePerms<ChannelsPermissionContext>({ canManage: false });
 * ```
 */
export function createModulePerms(defaults) {
    const PermsContext = createContext(defaults);
    function Provider(props) {
        return _jsx(PermsContext.Provider, { value: props.perms, children: props.children });
    }
    function usePerms() {
        return useContext(PermsContext);
    }
    return { Provider, usePerms };
}
//# sourceMappingURL=module-perms.js.map